import React, { useEffect, useState } from 'react';
import { WithApp } from 'contexts/appContext';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import InputLabel from '@material-ui/core/InputLabel';

// @material-ui/icons
import { Map, PermIdentity } from '@material-ui/icons';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Clearfix from 'components/Clearfix/Clearfix.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import moment from 'moment';

import styles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles.js';
import stylesInput from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { wsGetAll } from 'services/WService';
import { wsCreate, wsFindBy, wsGet, wsUpdate } from 'services/WService';
import { onlyInteger } from 'hooks/Pipe';
import CopyUserConfigurationModal from './CopyUserConfigurationModal';
import { useModal } from 'hooks/useModal';

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stylesInput,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  hr: {
    width: '93%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const defaults = { state: 'A', gender: 'M', type: 'A' };

export default WithApp(function UserCreate(props) {
  const { id } = useParams();

  const classes = useStyles();
  const [notify, showNotify] = useToasty(); //notificación despues de las

  const [data, setData] = useState(defaults);
  const [dataInitial, setDataInitial] = useState({});
  const [model, setOpen] = useModal();

  const [roles, setRoles] = useState([]);
  const [zones, setZones] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [zoneSelectes, setZoneSelectes] = useState([]);
  const existId = id == 0 ? true : false;

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const checkRoles = (id) => {
    let index = roles.findIndex((x) => x.id == id);
    let stateChecked = roles;
    stateChecked[index].checked = !roles[index].checked;
    setRoles([...stateChecked]);
  };

  const checkZones = (id) => {
    let index = zones.findIndex((x) => x.id == id);
    let stateChecked = zones;
    stateChecked[index].checked = !zones[index].checked;
    setZones([...stateChecked]);
  };

  const checkWarehouses = (id) => {
    let index = warehouses.findIndex((x) => x.id == id);
    let stateChecked = warehouses;
    stateChecked[index].checked = !warehouses[index].checked;
    setWarehouses([...stateChecked]);
  };

  /**
   *
   * @param {array} data recibe array y agrega checked false
   * @returns el nuevo array con el campo checked false
   */
  function mergeChecked(data, state) {
    let newData = data?.map((item) => {
      return { ...item, checked: state };
    });
    return newData;
  }

  async function getUser() {
    let response = await wsGet('oauth/user', id);
    if (response.success) {
      setData(response.data);
      setDataInitial(response.data);
      getRoles(true, mergeChecked(response.data.roles, true));
      listZones(true, mergeChecked(response.data.zones, true));
      let idZones = response.data.zones.map((item) => item.id);
      setZoneSelectes([...zoneSelectes, ...idZones]);
      setWarehouses(mergeChecked(response.data.warehouses, true));
      if (idZones.length > 0) {
        getWarehouses(idZones, mergeChecked(response.data.warehouses, true));
      }
    }
  }

  async function getRoles(isUpdate, rolesUser) {
    let response = await wsGetAll('oauth/roles');
    if (response.success) {
      let data = mergeChecked(response.data, false);
      if (isUpdate) {
        data = data.map((obj) => rolesUser.find((x) => x.id === obj.id) || obj);
      }
      setRoles(data);
    }
  }

  async function listZones(isUpdate, zonesUser) {
    let response = await wsGetAll('base/zone');
    if (response.success) {
      let data = mergeChecked(response.data, false);
      if (isUpdate) {
        data = data.map((obj) => zonesUser.find((o) => o.id === obj.id) || obj);
      }
      setZones(data);
    }
  }

  async function getWarehouses(zones, warehouses) {
    let response = await wsFindBy('logi/warehouse', { base_zone_id: zones });
    if (response.success) {
      let data = mergeChecked(response.data, false).map((obj) => {
        return warehouses.find((x) => x.id === obj.id) || obj;
      });
      setWarehouses(data);
    }
  }

  function filterData() {
    let _roles = roles.filter((item) => item.checked == true).map((item) => item.id);
    let _zones = zones.filter((item) => item.checked == true).map((item) => item.id);
    let _warehouses = warehouses.filter((item) => item.checked == true).map((item) => item.id);
    return { roles: _roles, zones: _zones, warehouses: _warehouses };
  }

  async function createUser() {
    let ids = filterData();
    if (ids.zones.length < 1 && ids.warehouses.length < 1) {
      showNotify('Zonas y almacénes son requeridos', 'info');
      return;
    }
    let mergeData = { ...data, roles: ids.roles, zones: ids.zones, warehouses: ids.warehouses };
    let response = await wsCreate('oauth/user', mergeData);
    if (response.success) {
      showNotify(response.message);
      syncZonesWarehouses(response.data.id);
      syncRoles(response.data.id);
      getRoles();
      listZones();
      setZoneSelectes([]);
      setData(defaults);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function updateUser() {
    let rolesIni = dataInitial.roles.map((item) => item.id);
    let zonesIni = dataInitial.zones.map((item) => item.id);
    let warehousesIni = dataInitial.warehouses.map((item) => item.id);

    let ids = filterData();
    const _roles = JSON.stringify(rolesIni) == JSON.stringify(ids.roles);
    const _zones = JSON.stringify(zonesIni) == JSON.stringify(ids.zones);
    const _warehouses = JSON.stringify(warehousesIni) == JSON.stringify(ids.warehouses);

    let newData = {};
    for (let key of Object.keys(data)) {
      if (dataInitial[key] != data[key]) {
        newData[key] = data[key];
      }
    }

    if (!_roles) {
      syncRoles(dataInitial.id);
    }

    if (!_zones || !_warehouses) {
      syncZonesWarehouses(dataInitial.id);
    }

    if (Object.keys(newData).length > 0) {
      let response = await wsUpdate('oauth/user', dataInitial.id, newData);
      if (response.success) {
        showNotify(response.message);
      } else {
        showNotify(response.message, 'error');
      }
    }
  }

  async function syncZonesWarehouses(idUser) {
    let ids = filterData();

    if (ids.zones.length > 0 && ids.warehouses.length < 1) {
      showNotify('Selecciona uno o más almacenes', 'info');
      return;
    }
    let response = await wsUpdate(`oauth/user/${idUser}/zone`, {
      zones: ids.zones,
      warehouses: ids.warehouses,
    });
    if (response.success) {
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function syncRoles(idUser) {
    let ids = filterData();
    let response = await wsCreate('oauth/authorizations/sync-roles-to-user', {
      user_id: idUser,
      roles: ids.roles,
    });
    if (response.success) {
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (id == 0) {
      getRoles();
      listZones();
    } else {
      getUser();
    }
  }, []);

  useEffect(() => {
    if (zoneSelectes.length > 0) {
      getWarehouses(zoneSelectes, warehouses);
    } else {
      setWarehouses([]);
    }
  }, [zoneSelectes]);

  return (
    <>
      <Toasty action={notify} />
      <CopyUserConfigurationModal model={model} setOpen={setOpen} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          existId ? createUser() : updateUser();
        }}
      >
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <Card>
              <CardHeader icon>
                <CardIcon color="primary">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Roles</h4>
              </CardHeader>
              <CardBody style={{ overflow: 'auto', maxHeight: '350px' }}>
                {roles.map((item) => {
                  const labelId = `checkbox-list-label-${item.id}`;
                  return (
                    <ListItem button dense key={item.id} onClick={() => checkRoles(item.id)}>
                      <ListItemIcon>
                        <Checkbox edge="start" checked={item.checked} />
                      </ListItemIcon>
                      <ListItemText id={labelId} primary={item.name} />
                    </ListItem>
                  );
                })}
              </CardBody>
            </Card>
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardHeader icon>
                    <CardIcon color="primary">
                      <Map />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>Zonas</h4>
                  </CardHeader>
                  <CardBody style={{ overflow: 'auto', maxHeight: '350px' }}>
                    {zones.map((item) => {
                      const labelId = `checkbox-list-label-${item.id}`;
                      return (
                        <ListItem
                          button
                          dense
                          key={item.id}
                          onClick={(e) => {
                            let inputCheck = e.currentTarget.parentElement.querySelector(
                              '#check' + item.id,
                            );
                            /* inputCheck.click(); */
                            checkZones(item.id);
                            if (!inputCheck.checked) {
                              setZoneSelectes([...zoneSelectes, item.id]);
                            } else {
                              let filter = zoneSelectes.filter((x) => x != item.id);
                              setZoneSelectes([...filter]);
                            }
                          }}
                        >
                          <ListItemIcon>
                            <Checkbox
                              id={'check' + item.id.toString()}
                              edge="start"
                              checked={item.checked}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setZoneSelectes([...zoneSelectes, item.id]);
                                } else {
                                  let filter = zoneSelectes.filter((x) => x != item.id);
                                  setZoneSelectes([...filter]);
                                }
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText id={labelId} primary={item.description} />
                        </ListItem>
                      );
                    })}
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <Button
                  color="reddit"
                  onClick={() => {
                    setOpen(data);
                  }}
                >
                  Copiar configuración
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={9}>
            <Card>
              <CardHeader icon>
                <CardIcon color="primary">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Datos de usuario</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={8}>
                    <TextField
                      required={existId}
                      label="Nombre"
                      name="name"
                      margin="normal"
                      fullWidth
                      value={data.name || ''}
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      label="Celular"
                      name="phone"
                      margin="normal"
                      type="text"
                      fullWidth
                      value={data.phone || ''}
                      inputProps={{ maxLength: 9, minLength: 0 }}
                      onChange={handleChange}
                      onKeyPress={(e) => onlyInteger(e)}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      required={existId}
                      label="Email para notificaciones"
                      name="notification_email"
                      margin="normal"
                      fullWidth
                      value={data.notification_email || ''}
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      required={existId}
                      label="Email para envio de reportes"
                      name="email_2"
                      margin="normal"
                      fullWidth
                      value={data.email_2 || ''}
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small" required={existId}>
                      <InputLabel>Envio de reportes</InputLabel>
                      <Select
                        value={
                          data.send_report === undefined || data.send_report === null ||
                          data.send_report === '' ? '' : data.send_report == 1 ? '1' : '0'
                        }
                        inputProps={{
                          name: 'send_report',
                          onChange: handleChange,
                        }}
                      >
                        <MenuItem value="1">Enviar</MenuItem>
                        <MenuItem value="0">No enviar</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <TextField
                      label="Fecha nacimiento"
                      type="date"
                      name="birthday"
                      value={moment(data.birthday).format('YYYY-MM-DD') || ''}
                      margin="normal"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small" required={existId}>
                      <InputLabel>Género</InputLabel>
                      <Select
                        value={data.gender || ''}
                        inputProps={{
                          name: 'gender',
                          onChange: handleChange,
                        }}
                      >
                        <MenuItem value="M">Masculino</MenuItem>
                        <MenuItem value="F">Femenino</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small" required={existId}>
                      <InputLabel>Tipo de usuario</InputLabel>
                      <Select
                        value={data.type || ''}
                        inputProps={{
                          name: 'type',
                          onChange: handleChange,
                        }}
                      >
                        <MenuItem value="A">Web</MenuItem>
                        <MenuItem value="U">Móvil</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={8}>
                    <TextField
                      label="Dirección"
                      name="address"
                      margin="normal"
                      fullWidth
                      value={data.address || ''}
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small" required={existId}>
                      <InputLabel>Estado</InputLabel>
                      <Select
                        value={data.state || ''}
                        inputProps={{
                          name: 'state',
                          onChange: handleChange,
                        }}
                      >
                        <MenuItem value="A">Activo</MenuItem>
                        <MenuItem value="I">Inactivo</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <Clearfix />
              </CardBody>
            </Card>

            <Card style={{ marginTop: '40px' }}>
              <CardHeader icon>
                <CardIcon color="primary">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Datos de acceso</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      required={existId}
                      label="Email o DNI"
                      name="email"
                      margin="normal"
                      fullWidth
                      value={data.email || ''}
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      required={existId}
                      label="Contraseña"
                      name="password"
                      margin="normal"
                      fullWidth
                      value={data.password || ''}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>

            <Card style={{ marginTop: '40px' }}>
              <CardHeader icon>
                <CardIcon color="primary">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Almacénes</h4>
              </CardHeader>
              <CardBody style={{ overflow: 'auto', maxHeight: '350px' }}>
                {warehouses.length > 0 ? (
                  warehouses.map((item) => {
                    const labelId = `checkbox-list-label-${item.id}`;
                    return (
                      <ListItem button dense key={item.id} onClick={() => checkWarehouses(item.id)}>
                        <ListItemIcon>
                          <Checkbox edge="start" checked={item.checked} />
                        </ListItemIcon>
                        <ListItemText id={labelId} primary={item.WhsName} />
                      </ListItem>
                    );
                  })
                ) : (
                  <p>Marque zonas para mostrar almacénes...</p>
                )}
              </CardBody>
            </Card>
            <AllowedGuard permission={ConstantPermissions.OAUTH_USERS_STORE}>
              <Button
                color={
                  existId
                    ? props.themeContext.buttonColorSuccess
                    : props.themeContext.buttonColorWarning
                }
                type="submit"
                style={{ float: 'right' }}
              >
                Guardar
              </Button>
            </AllowedGuard>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
});
